/**
 * Sunday: clips inside article bodies (figure.sd-xfig video). 22 Oct 2026.
 * The article's HTML carries the clip with preload="none" and no autoplay; here it plays, muted and looping,
 * only while at least 40% of it is on screen, and one at a time. Reduced motion or data saver: the poster stays.
 * No words here.
 */
import { play, prep } from '@sunday/util';

const vids = [...document.querySelectorAll('.sd-xfig video')];
if (vids.length) {
  const calm = !!(navigator.connection && navigator.connection.saveData); /* 24 Oct: reduced motion no longer stops it */
  for (const v of vids) {
    prep(v);
    v.loop = true;
    v.removeAttribute('autoplay');
  }
  if (!calm && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      for (const e of entries) {
        const v = e.target;
        if (e.isIntersecting && e.intersectionRatio >= 0.4) {
          for (const o of vids) if (o !== v && !o.paused) o.pause();
          play(v);
        } else if (!v.paused) {
          v.pause();
        }
      }
    }, { threshold: [0, 0.4] });
    vids.forEach((v) => io.observe(v));
  }
}
